<template>
  <div class="list__item flex flex-col leading-normal px-6 py-2">
    <div class="flex items-baseline">
      <div class="flex-1">
        {{ item.name }}
      </div>
      <div v-if="!selected && item.price > 0" class="w-32 px-4 uppercase text-right font-semibold">
        {{ item.price }} euro
      </div>
      <div class="flex-none -mr-2">
        <BaseLinkButton
          v-if="!selected"
          key="actionAdd"
          role="button"
          :purple="isOptional"
          @click="add"
        >
          προσθηκη
        </BaseLinkButton>
        <BaseLinkButton
          v-else-if="item.optional"
          key="actionRemove"
          role="button"
          tabindex="1"
          :purple="isOptional"
          @click="remove"
        >
          αφαιρεση
        </BaseLinkButton>
      </div>
      <div v-if="selected && item.price > 0" class="w-32 pl-4 uppercase text-right font-semibold">
        {{ item.price }} euro
      </div>
    </div>
  </div>
</template>

<script>
import { entityComputed } from '@/store/helper';

export default {
  name: 'OrderItem',
  props: {
    item: {
      type: Object,
      required: true,
    },
    selected: Boolean,
    selectedUpgradeOptionId: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    listUpgrades: false,
  }),
  computed: {
    ...entityComputed,
    isOptional() {
      return this.item.optional;
    },
    orderItemStateClasses() {
      return {
        border: true,
        'border-gray-400': !this.selected,
        rounded: true,
        'bg-white': this.selected,
        'shadow-lg': this.selected,
        'border-white': this.selected,
      };
    },
    product() {
      return this.entityById('products', this.item.productId);
    },
  },
  methods: {
    add() {
      this.$emit('add');
    },
    remove() {
      this.$emit('remove');
    },
  },
};
</script>
